import React, { useState } from 'react';
import AdminUsersTab from '../components/admin/AdminUsersTab';
import AdminActivityTab from '../components/admin/AdminActivityTab';
import AdminStatsTab from '../components/admin/AdminStatsTab';
import AdminSettingsTab from '../components/admin/AdminSettingsTab';
import AdminTemplatesTab from '../components/admin/AdminTemplatesTab';
import { Users, ListChecks, BarChart3, Settings, LayoutTemplate } from 'lucide-react';

type AdminTab = 'users' | 'activity' | 'stats' | 'templates' | 'settings';

const TABS: Array<{ id: AdminTab; label: string; icon: React.ElementType }> = [
  { id: 'users', label: 'Users', icon: Users },
  { id: 'activity', label: 'Activity Logs', icon: ListChecks },
  { id: 'stats', label: 'Statistics', icon: BarChart3 },
  { id: 'templates', label: 'Templates', icon: LayoutTemplate },
  { id: 'settings', label: 'Settings', icon: Settings },
];

const Admin: React.FC = () => {
  const [tab, setTab] = useState<AdminTab>('users');

  return (
    <div className="max-w-[1200px] mx-auto">
      <h1 className="text-foreground mb-6 text-2xl font-display font-semibold tracking-tight">
        Admin Dashboard
      </h1>

      <div className="flex gap-1 bg-white border border-zinc-200 rounded-card p-1 mb-6 w-fit">
        {TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`h-9 px-4 rounded-[calc(12px-4px)] text-sm font-medium inline-flex items-center gap-1.5 transition-colors border-none cursor-pointer ${
              tab === t.id ? 'bg-brand-500 text-white shadow-soft' : 'text-secondary-foreground hover:text-foreground hover:bg-subtle'
            }`}
          >
            <t.icon className="w-4 h-4" />
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'users' && <AdminUsersTab />}
      {tab === 'activity' && <AdminActivityTab />}
      {tab === 'stats' && <AdminStatsTab />}
      {tab === 'templates' && <AdminTemplatesTab />}
      {tab === 'settings' && <AdminSettingsTab />}
    </div>
  );
};

export default Admin;
